var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "gliderEl", staticClass: "glider-carousel" }, [
    _c(
      "div",
      { ref: "gliderCarouselEl", staticClass: "carousel-items" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.arrows
      ? _c("div", { staticClass: "glider-btn-wrapper glider-prev-wrapper" }, [
          _c(
            "div",
            {
              ref: "gliderPrevEl",
              staticClass: "btn btn-default glider-btn glider-btn-prev",
            },
            [_c("i", { staticClass: "icon ion-ios-arrow-back" })]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.arrows
      ? _c("div", { staticClass: "glider-btn-wrapper glider-next-wrapper" }, [
          _c(
            "div",
            {
              ref: "gliderNextEl",
              staticClass: "btn btn-default glider-btn glider-btn-next",
            },
            [_c("i", { staticClass: "icon ion-ios-arrow-forward" })]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/GliderCarousel/template.html?vue&type=template&id=52ef7340&
// module id = 1051
// module chunks = 0